// extracted by mini-css-extract-plugin
export default {"input":"AdminReporting_input__hyrck","actions":"AdminReporting_actions__ItUKv","columnsTable":"AdminReporting_columnsTable__iFPXv"};